import {
  React,
  Component
} from 'imports/CommonImports';

import {
  PrimaryColor1,
  PrimaryColor2
} from 'imports/DesignImports';

import{
  DoneIcon
} from 'imports/IconsImports';

import {
  Step,
  Stepper,
  StepLabel,
} from 'material-ui';

/**
 * Horizontal steppers are ideal when the contents of one step depend on an earlier step.
 * Avoid using long step names in horizontal steppers.
 *
 * Linear steppers require users to complete one step in order to move on to the next.
 */

 const styles = {
  link: {
    textDecoration: "none"
   },
  color: {
    backgroundColor: PrimaryColor1,
    color: PrimaryColor1
   },
  completedCircle:{
    display: "inline-block",
    borderRadius: "60px",
    boxShadow: "0px 0px 2px #9e9e9e",
    padding: "0.5em 0.6em",
  },
  activeCircle:{
    display: "inline-block",
    borderRadius: "60px",
    boxShadow: "0px 0px 2px #1b2543",
    padding: "0.5em 0.6em",
    backgroundColor: "#1b2543"
   },
   nextCircle:{
    display: "inline-block",
    borderRadius: "60px",
    boxShadow: "0px 0px 2px #9e9e9e",
    padding: "0.5em 0.6em",
   }
 }

class HorizontalStepper extends Component {
  constructor(props){
    super(props);
    this.state = {
      steps: this.props.step
    };
  }

  render() {
    return (
      <div>
      { this.state.steps !== "error" ?
          this.stepToCode(this.state.steps)
      :
        null
      }
      </div>
    );
  }

  stepToCode = (step) => {
    switch (step) {
      case "setup":
        return(
          <Stepper>
            <Step>
              {this.activeStep("Fechas del proceso", 1)}
            </Step>
            <Step>
              {this.nextStep("Postulación de Proyectos",2)}
            </Step>
            <Step>
              {this.nextStep("Filtro Innovación",3)}
            </Step>
            <Step>
              {this.nextStep("Fichas de Proyectos", 4)}
            </Step>
            <Step>
              {this.nextStep("Filtro Económico", 5)}
            </Step>
          </Stepper>
        );
      case "postulation":
        return(
          <Stepper>
            <Step>
              {this.completedStep("Fechas del proceso")}
            </Step>
            <Step>
              {this.activeStep("Postulación de Proyectos",2)}
            </Step>
            <Step>
              {this.nextStep("Filtro Innovación",3)}
            </Step>
            <Step>
              {this.nextStep("Fichas de Proyectos", 4)}
            </Step>
            <Step>
              {this.nextStep("Filtro Económico", 5)}
            </Step>
          </Stepper>
        );
      case "selection_criterias":
        return(
          <Stepper>
            <Step>
              {this.completedStep("Fechas del proceso")}
            </Step>
            <Step>
              {this.completedStep("Postulación de Proyectos")}
            </Step>
            <Step>
              {this.activeStep("Filtro Innovación",3)}
            </Step>
            <Step>
              {this.nextStep("Fichas de Proyectos", 4)}
            </Step>
            <Step>
              {this.nextStep("Filtro Económico", 5)}
            </Step>
          </Stepper>
        );
      case "files":
        return(
          <Stepper>
            <Step>
              {this.completedStep("Fechas del proceso")}
            </Step>
            <Step>
              {this.completedStep("Postulación de Proyectos")}
            </Step>
            <Step>
              {this.completedStep("Filtro Innovación")}
            </Step>
            <Step>
              {this.activeStep("Fichas de Proyectos", 4)}
            </Step>
            <Step>
              {this.nextStep("Filtro Económico", 5)}
            </Step>
          </Stepper>
        );
      case "selection_economic":
        return(
          <Stepper>
            <Step>
              {this.completedStep("Fechas del proceso")}
            </Step>
            <Step>
              {this.completedStep("Postulación de Proyectos")}
            </Step>
            <Step>
              {this.completedStep("Filtro Innovación")}
            </Step>
            <Step>
              {this.completedStep("Fichas de Proyectos")}
            </Step>
            <Step>
              {this.activeStep("Filtro Económico", 5)}
            </Step>
          </Stepper>
        );
      case "done":
        return(
          <Stepper>
            <Step>
              {this.completedStep("Fechas del proceso")}
            </Step>
            <Step>
              {this.completedStep("Postulación de Proyectos")}
            </Step>
            <Step>
              {this.completedStep("Filtro Innovación")}
            </Step>
            <Step>
              {this.completedStep("Fichas de Proyectos")}
            </Step>
            <Step>
              {this.completedStep("Filtro Económico")}
            </Step>
          </Stepper>
        );
      default:
        return "error";
    }
  }


  completedStep(step){
    return(<StepLabel icon={<div style={styles.completedCircle}><DoneIcon style={{color:PrimaryColor2}} /></div>}><p style={{color:PrimaryColor2}}>{step}</p></StepLabel>);
  }

  activeStep(step, index){
    return(<StepLabel icon={<div style={styles.activeCircle}><span style={{color:'white', margin:'5px', fontSize:'1.5em'}}>{index}</span></div>}><p style={{color:PrimaryColor1}}>{step}</p></StepLabel>);
  }
  nextStep(step, index){
    return(<StepLabel icon={<div style={styles.nextCircle}><span style={{color:PrimaryColor2, margin:'5px', fontSize:'1.5em'}}>{index}</span></div>}><p style={{color:PrimaryColor2}}>{step}</p></StepLabel>);
  }
}

export default HorizontalStepper;



// WEBPACK FOOTER //
// ./src/components/design/Stepper.js